"use strcit";

export default {
  resellerOrders(state) {
    return state.resellerOrders;
  },
};
